import React from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import BgImg from '../../../assets/images/blog/careers.png'
import jobs from '../../../data/jobs'

const JobDetails = () => {
    const { slug } = useParams()
    const job = jobs.find((j) => j.slug === slug)

    if (!job) {
        return <Navigate to="/careers" replace />
    }

    return (
        <>
            <Breadcumb Title={job.title} Breadcumb="CAREERS" BgImg={BgImg} />
            <section className="section-padding--top section-padding--bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="blog-card-one__meta">
                                <div className="blog-card-one__date">
                                    <i className="fa fa-briefcase" aria-hidden="true"></i>
                                    {job.type}
                                </div>
                                <span className="blog-card-one__category">{job.category}</span>
                            </div>
                            <h3 className="blog-card-one__title blog-details__title">{job.title}</h3>
                            <div className="blog-details__content">
                                <p>
                                    <i className="fa fa-map-marker-alt" aria-hidden="true"></i>{' '}
                                    {job.location}
                                </p>
                                <p>{job.summary}</p>

                                <h4>What you will do</h4>
                                <ul className="list-unstyled" style={{marginBottom: 30}}>
                                    {job.responsibilities.map((item) => (
                                        <li key={item} style={{marginBottom: 8}}>
                                            <i className="fa fa-check" aria-hidden="true" style={{marginRight: 10}}></i>
                                            {item}
                                        </li>
                                    ))}
                                </ul>

                                <h4>What we are looking for</h4>
                                <ul className="list-unstyled" style={{marginBottom: 30}}>
                                    {job.requirements.map((item) => (
                                        <li key={item} style={{marginBottom: 8}}>
                                            <i className="fa fa-check" aria-hidden="true" style={{marginRight: 10}}></i>
                                            {item}
                                        </li>
                                    ))}
                                </ul>

                                <h4>How to apply</h4>
                                <p>
                                    Send your CV and a short introduction to{' '}
                                    <a href={`mailto:info@beettechnologies.com?subject=${encodeURIComponent(`Application: ${job.title}`)}`}>
                                        info@beettechnologies.com
                                    </a>{' '}
                                    with the role title in the subject line, or get in touch via our contact page.
                                </p>
                            </div>

                            <div style={{display: 'flex', gap: 20, flexWrap: 'wrap', marginTop: 30}}>
                                <a
                                    href={`mailto:info@beettechnologies.com?subject=${encodeURIComponent(`Application: ${job.title}`)}`}
                                    className="thm-btn"
                                >
                                    <span>Apply Now</span>
                                </a>
                                <Link to="/careers" className="thm-btn">
                                    <span>Back to Careers</span>
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="gray-bg" style={{padding: 30}}>
                                <h4 style={{marginBottom: 20}}>Role Overview</h4>
                                <ul className="list-unstyled" style={{marginBottom: 0}}>
                                    <li style={{marginBottom: 12}}>
                                        <i className="fa fa-briefcase" aria-hidden="true" style={{marginRight: 10}}></i>
                                        {job.type}
                                    </li>
                                    <li style={{marginBottom: 12}}>
                                        <i className="fa fa-layer-group" aria-hidden="true" style={{marginRight: 10}}></i>
                                        {job.category}
                                    </li>
                                    <li style={{marginBottom: 0}}>
                                        <i className="fa fa-map-marker-alt" aria-hidden="true" style={{marginRight: 10}}></i>
                                        {job.location}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default JobDetails
